import React, { useState } from "react";
import { Plus } from "lucide-react";

const SAMPLE_QUESTIONS = [
  { icon: "🔍", text: "Which dataset should I use to analyse inventory levels by warehouse?" },
  { icon: "📊", text: "How many active data assets are under the Supply Chain domain?" },
  // { icon: "⚠️", text: "Which assets have the worst average DQ score this month?" },
  { icon: "🗂️", text: "Show all sub-domains under Operations parent domain." },
  { icon: "❓", text: "Find me the inventory data." },
  // { icon: "🔗", text: "Find the best inventory table, its DQ score, and owner." },
  // { icon: "📋", text: "How many columns does inventory_stock_detail have?" },
  { icon: "📁", text: "What columns and tables do I need to arrive at the Stock Turnover KPI?" },
  { icon: "🌐", text: "What inventory assets are available in North America?" },
  // { icon: "🔄", text: "What are the downstream consumers of inventory_stock_detail?" },
  // { icon: "🔐", text: "I want to request access to inventory_stock_detail." },
  // { icon: "📈", text: "What is the overall DQ score for my Supply Chain domain?" },
];

export default function SampleQuestionsSidebar({ onQuestionClick, onNewChat }) {
  const [sidebarWidth, setSidebarWidth] = useState(288); // w-72 = 288px
  const [isCollapsed, setIsCollapsed] = useState(false);

  const handleMouseDown = (e) => {
    if (isCollapsed) return;
    e.preventDefault();
    document.body.style.userSelect = "none";
    document.body.style.cursor = "col-resize";

    const startX = e.clientX;
    const startWidth = sidebarWidth;

    const onMouseMove = (e) => {
      const newWidth = Math.min(400, Math.max(180, startWidth + (e.clientX - startX)));
      setSidebarWidth(newWidth);
    };

    const onMouseUp = () => {
      document.body.style.userSelect = "";
      document.body.style.cursor = "";
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };

    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <div
      className="border-r border-gray-200 flex-shrink-0 relative flex flex-col h-full bg-white"
      style={{
        width: isCollapsed ? "0px" : `${sidebarWidth}px`,
        overflow: "visible",
        transition: "width 0.22s cubic-bezier(.4,0,.2,1)",
        minWidth: isCollapsed ? "15px" : undefined,
      }}
    >
      <div
        style={{
          opacity: isCollapsed ? 0 : 1,
          transition: "opacity 0.15s",
          overflow: "hidden",
          width: `${sidebarWidth}px`,
          height: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {/* Title */}
        <div className="px-4 pt-4 pb-2">
          <p className="text-xs font-semibold text-gray-400 uppercase tracking-widest">
            Sample Questions
          </p>
        </div>

        {/* Questions list */}
        <div className="flex-1 overflow-y-auto px-3 pb-2">
          <div className="flex flex-col gap-0.5">
            {SAMPLE_QUESTIONS.map((q, i) => (
              <button
                key={i}
                onClick={() => onQuestionClick?.(q.text)}
                className="flex items-start gap-2 px-2 py-2 rounded-lg hover:bg-indigo-50 text-left transition-colors group w-full"
              >
                <span className="text-base mt-0.5 shrink-0">{q.icon}</span>
                <span className="text-xs text-gray-600 group-hover:text-indigo-700 leading-snug">
                  {q.text}
                </span>
              </button>
            ))}
          </div>
        </div>

        {/* New Chat button */}
        <div className="p-4 border-t border-gray-100">
          <button
            onClick={onNewChat}
            className="flex items-center justify-center gap-2 w-full py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-normal transition-colors"
          >
            <Plus size={13} />
            New Chat
          </button>
        </div>
      </div>

      {/* Resize handle */}
      <div
        onMouseDown={handleMouseDown}
        onMouseEnter={(e) => { if (!isCollapsed) e.currentTarget.style.backgroundColor = "#bb1ccc"; }}
        onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "transparent")}
        className={`absolute top-0 right-0 h-full w-[4px] transition-colors duration-150 z-10 ${
          isCollapsed ? "cursor-default" : "cursor-col-resize"
        }`}
      />

      {/* Collapse toggle button */}
      <button
        onClick={() => setIsCollapsed((prev) => !prev)}
        className="absolute top-1/2 -translate-y-1/2 -right-[13px] w-[26px] h-[26px] rounded-full bg-[#bb1ccc] border-2 border-white flex items-center justify-center cursor-pointer z-30 shrink-0"
      >
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          className="transition-transform duration-[220ms]"
          style={{ transform: isCollapsed ? "rotate(180deg)" : "rotate(0deg)" }}
        >
          <path
            d="M7 2L3 6L7 10"
            stroke="white"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
    </div>
  );
}